export const LOCAL_STORAGE = {
  JWT_TOKEN: 'jwt_token',
};

export const TEST_LEAGUE_IDS: string[] = [
  '612a66c17c881d001744f62d', //api_testing
  '5f3d99a25d018c175707cb4e', //dev testing
  '5fda6c2655ec2021fe1b523f', //portfolio demo
];
